<div class="p-8 rounded-lg bg-gray-100 w-full min-h-16">
    <form #f="ngForm" class="flex flex-col gap-4">
        <div class="w-full flex justify-between items-start gap-4 " livecoAppearance>
            <div class="flex flex-wrap gap-4 flex-grow">
                <!-- Filter name || numP -->
                <mat-form-field class='w-[21rem]' [ngClass]="{'w-full': !(isCPP() || isFab())}">
                    <mat-label>{{'FILTERS.NAME_OR_ID'| translate}}</mat-label>
                    <input matInput name="text" [(ngModel)]="filters.__search" type="text">
                </mat-form-field>
                <ng-container *ngIf="isCPP() || isFab()">
                    <!-- Date start -->
                    <mat-form-field class="fix-picker w-[10rem]">
                        <mat-label>{{ "FILTERS.START_DATE" | translate }}</mat-label>
                        <input matInput [matDatepicker]="pickerStart" name="date_start" type="text" [(ngModel)]="filters.date_start" (ngModelChange)="onDateSelected('start')" />
                        <mat-datepicker-toggle matSuffix [for]="pickerStart" class="flex flex-col justify-center items-center"></mat-datepicker-toggle>
                        <mat-datepicker #pickerStart></mat-datepicker>
                    </mat-form-field>
                    <!-- Date end -->
                    <mat-form-field class="fix-picker w-[10rem]">
                        <mat-label>{{ "FILTERS.END_DATE" | translate }}</mat-label>
                        <input matInput [matDatepicker]="pickerEnd" name="date_end" type="text" [(ngModel)]="filters.date_end" (ngModelChange)="onDateSelected('end')" />
                        <mat-datepicker-toggle matSuffix [for]="pickerEnd" class="flex flex-col justify-center items-center"></mat-datepicker-toggle>
                        <mat-datepicker #pickerEnd></mat-datepicker>
                    </mat-form-field>
                </ng-container>
            </div>
            <div class="flex flex-wrap gap-4 justify-end max-w-[50%]" *ngIf="isCPP() || isClient() || isFab() || isOperator()">
                <!-- PROOFREADING STATE -->
                <div class="flex flex-col w-[10rem]" *ngIf="isCPP() || isClient() || isFab()">
                    <mat-form-field class="w-[10rem]">
                        <mat-label>{{ 'GROUP.STATE' | translate }}</mat-label>
                        <mat-select [(ngModel)]="filters.state_slugs" name="state_slugs" multiple (ngModelChange)="updateAllProjectsState()">
                            <mat-option *ngFor="let state of states_slugs" [value]="state">
                                <div class="flex gap-1 items-center justify-around">
                                    <span [ngClass]="state">{{ 'EXTERN.DASHBOARD.' + state | uppercase | translate }}</span>    
                                </div>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <!-- PROOFREADING FLOW -->
                <div class="flex flex-col w-[10rem]" *ngIf="isCPP() || isClient() || isFab()">
                    <mat-form-field class="w-[10rem]">
                        <mat-label>{{ 'FLOW' | translate }}</mat-label>
                        <mat-select [(ngModel)]="filters.flows_slugs" name="flows_slugs" multiple (ngModelChange)="updateAllProjectsState()">
                            <mat-option *ngFor="let flow of flows_slugs" [value]="flow">
                                <div class="flex gap-1 items-center justify-around">
                                    <span>{{ flow | uppercase | translate }}</span>    
                                </div>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <ng-container *ngIf="isCPP() || isFab()">
                    <div class="flex flex-col w-[10rem]">
                        <app-autocomplete-filter-model livecoAppearance [label]="'GROUP.CPP'" [error]="'VALIDATORS.FORMDIALOG-CPP'" [(ngModel)]="filters.cpp" ngDefaultControl [options]="cpps" [name]="'cpp'" [filterKey]="'username'" (ngModelChange)="updateAllProjectsState()">
                        </app-autocomplete-filter-model>
                    </div>
                </ng-container>
                <ng-container *ngIf="isCPP() || isFab() || isOperator()">
                    <div class="flex flex-col w-[10rem]">
                        <app-autocomplete-filter-model livecoAppearance [label]="'GROUP.CUSTOMERS'" [error]="'VALIDATORS.FORMDIALOG-CUSTOMER'" [(ngModel)]="filters.customer" ngDefaultControl [options]="customers" [name]="'client'" [filterKey]="'name'" (ngModelChange)="updateAllProjectsState()">
                        </app-autocomplete-filter-model>
                    </div>
                    <div class="flex flex-col w-[10rem]">
                        <app-autocomplete-filter-model livecoAppearance [label]="'GROUP.BRANDS'" [error]="'VALIDATORS.FORMDIALOG-BRANDS'" [(ngModel)]="filters.brand" ngDefaultControl [options]="brands" [name]="'marque'" [filterKey]="'label'">
                        </app-autocomplete-filter-model>
                    </div>
                    <div class="flex flex-col w-[10rem]">
                        <app-autocomplete-filter-model livecoAppearance [label]="'PRINTER.PRINTERS'" [error]="'VALIDATORS.FORMDIALOG-PRINTERS'" [(ngModel)]="filters.printer" ngDefaultControl [options]="printers" [name]="'printer'" [filterKey]="'custom.printer_info.name'">
                        </app-autocomplete-filter-model>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="flex flex-row justify-start items-start w-full gap-2" *ngIf="isClient() || isCPP() || isFab()">
            <ng-container *ngIf="isClient() && (marqueLabel || customerName)">
                <mat-checkbox [(ngModel)]="filters.all_customer_project" name="idCustomer">{{ 'PROJECT.FILTERS.PROJECTS' | translate }} {{ marqueLabel || customerName }} </mat-checkbox>
                <mat-checkbox [(ngModel)]="filters.projects_archived" name="projects_archived" (ngModelChange)="updateAllProjectsState()">{{ 'PROJECT.FILTERS.PROJECTS_ARCHIVED' | translate }} </mat-checkbox>
                <mat-checkbox [(ngModel)]="filters.is_old" name="oldProjects" (ngModelChange)="updateAllProjectsState()">{{ 'PROJECT.FILTERS.OLD_PROJECTS' | translate }} </mat-checkbox>
            </ng-container>
            <ng-container *ngIf="isCPP() || isFab()">
                <div class="flex gap-2">
                    <mat-checkbox [(ngModel)]="filters.all_project" name="allProject" [disabled]="!!filters.cpp || !!filters.projects_archived || !!filters.is_old">{{ 'PROJECT.FILTERS.PROJECTS' | translate }} </mat-checkbox>
                    <mat-checkbox [(ngModel)]="filters.projects_archived" name="projects_archived" (ngModelChange)="updateAllProjectsState()">{{ 'PROJECT.FILTERS.PROJECTS_ARCHIVED' | translate }} </mat-checkbox>
                    <mat-checkbox [(ngModel)]="filters.is_old" name="oldProjects" (ngModelChange)="updateAllProjectsState()">{{ 'PROJECT.FILTERS.OLD_PROJECTS' | translate }} </mat-checkbox>
                </div>
            </ng-container>
        </div>
        <div class="flex flex-row justify-end w-full gap-4">
            <button matButton (click)="resetForm()" class="flex flex-row justify-center items-center px-4 py-2 text-tw-darktext bg-tw-disabled rounded-lg" type="button">
                <mat-icon class="mr-2">restart_alt</mat-icon>
                <span>{{ 'FILTERS.REINIT' | translate }}</span>
            </button>
            <button matButton (click)="submit()" class="px-4 py-2 text-tw-lightgrey bg-tw-primary rounded-lg" type="submit">
                <span>{{ 'FILTERS.SEARCH' | translate }}</span>
            </button>
        </div>
    </form>
</div>